<template>
  <div class="tile-connection">
    <p class="number">{{ count }}</p>
    <p class="subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>

export default {
  props: {
    count: {
      type: [ Number, String],
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
  .tile-connection {
    height: 100%;
    width: 100%;
    background-color: #08344C;
  }
  .number {
    font-size: 48px;
    color: white;
    margin: 2rem 0 1rem 0;
  }

  @media (min-width: 1080px) {
    .number {
      margin: 2rem 0 0 0;
    }
  }

  @media (max-width: 768px) {
    .number {
      font-size: 36px;
      color: white;
      margin: 1rem 0 0 0;
    }
    .subtitle {
      font-size: 30px !important;
    }
  }
  @media (max-width: 414px) {
    .tile-connection {
      height: 50%;
      padding-bottom: 0.5rem;
    }
    .number {
      font-size: 30px;
       margin: 1rem 0 0 0;
    }
    .subtitle {
      font-size: 30px;
    }
  }
  .subtitle {
    font-size: 36px;
    color: white;
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>